import Vue from "vue";
import { type PlayableType } from "../../global/types/GlobalTypes";
import { songService } from '../../playable/SongService';
import { type AbstractPlayableContent } from "../../playable/models/AbstractPlayableContent";
import router from "../../../router";
import { schoolService } from "../../school/SchoolService";
import { SchoolModuleStepExercise } from "../../school/models/SchoolModuleSteps";
import { challengeService } from "../../playable/ChallengeService";
import { type Division } from "../../playable/models/Division";
import { playerConfig } from "./PlayerConfig";
import { userService } from "../../user/UserService";
import { type Exercise } from "src/modules/school/models/Exercise";

const EVALUATION_MODULE_ID = 23;
interface PlayerServiceState {
  playableContentType: PlayableType
  playerPlayableContent: null | AbstractPlayableContent
  divisions: Division[]
  hasPlayerPlayableContentMusicxml: boolean
  isScoreCalculating: boolean
  exercise: Exercise | null
}

class PlayerService {
  public readonly state = Vue.observable<PlayerServiceState>({
    playableContentType: 'version',
    playerPlayableContent: null,
    divisions: [],
    hasPlayerPlayableContentMusicxml: false,
    isScoreCalculating: false,
    exercise: null,
  })

  public async loadPlayableContent(playableType: PlayableType, playableId: number) {
    this.state.playableContentType = playableType

    if (playableType === 'version') {
      await songService.loadVersion(playableId, true)
      this.state.playerPlayableContent = songService.state.currentVersion
      this.state.divisions = playerConfig.state.playerMode === 'beat_practice' ? songService.state.beatPractice : songService.state.divisions
      this.state.hasPlayerPlayableContentMusicxml = this.state.playerPlayableContent.baseModel && this.state.playerPlayableContent.baseModel.has_musicxml_file
      return
    }

    if (playableType === 'challenge') {
      await challengeService.loadChallenge(playableId)
      this.state.playerPlayableContent = challengeService.state.currentChallenge
      this.state.divisions = Object.freeze(challengeService.state.challengeDivisions) as any
      this.state.hasPlayerPlayableContentMusicxml = this.state.playerPlayableContent.baseModel && this.state.playerPlayableContent.baseModel.piece_version && this.state.playerPlayableContent.baseModel.piece_version.has_musicxml_file
      return
    }

    if (playableType === 'section') {
      let result: { section: AbstractPlayableContent; divisions: Division[]; hasMusicxml: boolean, exercise: Exercise } | undefined

      if (router.currentRoute.name === 'Player School') {
        result = await schoolService.loadStepForSection(playableId)
        await schoolService.loadModule(result.exercise.school_module_id)
      }
      else if (router.currentRoute.name === 'Player Evaluation') {
        await schoolService.loadModule(EVALUATION_MODULE_ID)
        const localStorageItem = localStorage.getItem('evaluationData_' + userService.user.id)
        const stepId = localStorageItem ? JSON.parse(localStorageItem).currentStepIndex : 0
        const exerciseId = schoolService.state.activeModule && (schoolService.state.activeModule.content[stepId] as SchoolModuleStepExercise)?.exerciseId
        if (exerciseId) {
          result = await schoolService.loadStepForSection(exerciseId)
        }
      }

      if (result) {
        this.state.playerPlayableContent = result.section
        this.state.divisions = Object.freeze(result.divisions) as any
        this.state.hasPlayerPlayableContentMusicxml = result.exercise.has_musicxml_file || result.hasMusicxml
        this.state.exercise = result.exercise
      }
    }
  }

  public resetPlayableContent() {
    if (this.state.playableContentType === 'version') {
      songService.clearState()
      return
    }

    if (this.state.playableContentType === 'challenge') {
      challengeService.clearState()

    }
  }
}


export const playerService = new PlayerService()
